<template lang="html">
  <div class="tgfc">
    <div class="navbar">
      <ul class="navtab">
        <li @click="topath('/home')">直播课<span></span></li>
        <li class="active">投顾风采<span></span></li>
        <li @click="topath('/zjhz')">战绩汇总<span></span></li>
      </ul>
    </div>
    <ul class="tgfclist">
      <li v-for="item in list" @click="pictureshow(item.tel_path)">
        <div class="tehead">
          <img :src="item.head">
        </div>
        <div class="teinfo">
          <div class="name">
            <span>{{item.nickname}}</span>
            <span>{{item.position}}</span>
          </div>
          <div class="brief">{{item.remark}}</div>
        </div>
      </li>
    </ul>
    <!--图片预览-->
    <div class="preview" v-if="preview">
      <img :src="picsrc" @click="picturehide">
    </div>
  </div>
</template>

<script>
  import * as api from '../../api/api.js'
  export default {
    data() {
      return {
        list: [],
        picsrc: '',
        preview: false,
        rid: 4
      }
    },
    methods: {
      teaminfo: function () {
        this.axios.get(api.teamInfo + this.rid).then((res) => {
          let dataList = res.data.data;
          this.list = dataList;
        })
      },
      topath: function (url) {
        this.$router.push(url);
      },
      //图片预览
      pictureshow: function (src) {
        this.picsrc = src;
        this.preview = true;
      },
      //关闭图片预览
      picturehide: function () {
        this.preview = false;
      }
    },
    created() {
      const { rid } = this.$route.query
      this.rid = rid
      this.teaminfo();
    }
  }
</script>

<style lang="css" scoped>
  .tgfclist {
    padding: .2rem .3rem 0;
    background: #fff;
  }

  .tgfclist li {
    height: 2.98rem;
    background: #f4f4f4;
    margin-bottom: .2rem;
  }

  .tgfclist li .tehead {
    float: left;
    width: 1.9rem;
    height: 1.98rem;
    padding: .2rem;
  }

  .tgfclist li .tehead img {
    width: 1.5rem;
    height: 1.5rem;
  }

  .tgfclist li .teinfo {
    float: left;
    width: 72.4%;
    margin: 0 auto;
    padding: .12rem .2rem 0 0;
    font-size: .24rem;
    color: #666;
  }

  .teinfo .name {
    margin-bottom: .1rem;
    font-size: .24rem;
    color: #333;
  }

  .teinfo .name span:first-child {
    font-weight: 600;
    font-size: .3rem;
    margin-right: .22rem;
  }

  .teinfo .brief {
    line-height: .3rem;
  }

  .preview {
    position: fixed;
    width: 100%;
    max-width: 750px;
    min-width: 300px;
    height: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    background: #fff;
    z-index: 50;
    overflow-y: auto;
  }

  .preview img {
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/zb/tgfc.vue